"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _baseTheme = /*#__PURE__*/ _interop_require_default(require("./baseTheme"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var theme = function(param) {
    var fontFamily = (param === void 0 ? {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"'
    } : param).fontFamily;
    return (0, _baseTheme.default)({
        fontFamily: fontFamily,
        themeOverrides: {
            headerNavBg: "#fff",
            headerNavColor: "#FFF",
            brandColor: "#00af41",
            splashColor: "#44444F"
        }
    });
};
var _default = theme;
